/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const API_ENDPOINT = '/api'
export const API_VERSION = 'v1'

export const API_RESOURCE = {
  STACKS: 'stacks',
  EXTERNAL_ID: 'external-id',
  SCAN: 'statistics/scans',
  EVENT: 'events',
}

export const STACK_TYPE: { [key: string]: Response.Stack.StackType } = {
  SCANNER: 'scanner',
  STORAGE: 'storage',
}

export const PROVIDER: Record<string, Response.Stack.StackItemProvider> = {
  AWS: 'aws',
}

export const API_FSS_PATH = 'filestorage'

// C1C API
export const API_CLOUD_ACCOUNT_PATH = 'cloudaccounts'
export const API_GCP_OIDC_PATH = `${API_CLOUD_ACCOUNT_PATH}/gcp-projects`
export const API_OIDC_DOWNLOAD_TERRAFORM_GCP_TEMPLATE = `${API_CLOUD_ACCOUNT_PATH}/gcp/templates`
